<script setup lang="ts">
const props = defineProps<{
  videoInformation: VideoInformation
}>()

const id = computed<number>(() => Number.parseInt(props.videoInformation.id))

const options = {
  autoplay: true,
  playsinline: true,
  vimeo_logo: false,
  pip: false,
  interactive_markers: false,
  colors: ['#0B7CB9', '#26B489', '#D8F0FD', '#02151F'],
  chapters: false,
  title: false,
  volume: false,
}
</script>

<template>
  <ScriptVimeoPlayer :id="id" above-the-fold :vimeo-options="options" trigger="immediate" />
</template>
